import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { capitalize, enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { DATA_SENSITIVITY_LABELS, DataSensitivityLevelId } from '@sonar-software/sonar-core';
import { OptionFilter } from '@periscopes/general/filters';
export const options = enumNumericValues(DataSensitivityLevelId)
    .map((level) => ({
    label: DATA_SENSITIVITY_LABELS[level],
    value: level
}));
export const SensitivityLevelFilter = (props) => {
    const { format, id, label, onChange, value } = props;
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            value: options
                .filter((option) => {
                var _a;
                return (_a = (Array.isArray(value) ? value : [])) === null || _a === void 0 ? void 0 : _a.includes(option.value);
            })
                .map((option) => option.label)
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), mode: 'multiple', onChange: (selection) => onChange({
                [id]: {
                    format,
                    value: selection
                }
            }), options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(capitalize(label)), showArrow: true, value: value })));
};
